<img [src]="image.url" (click)="file.click()" class="image-upload" [ngClass]="componentClass"/>
<input #file type="file" accept="image/*" (change)="preview(file.files)" style="display:none;" />